module.exports = __webpack_public_path__ + "static/media/smokeless_supporter_logo_v.778c33ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/smokeless_supporter_logo_v.svg
// module id = 641
// module chunks = 0